export default __webpack_public_path__ + "images/d5dcb3cfa832ab579808c4577cc3925e-ticketing_sp1_1@2x.png";